import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import {
  BranchHealth,
  CriticalAlerts,
  DistrictDemand,
  EndOfDay,
  OperationBoard,
  RouteManagement,
  SummaryBoard,
  Vehicles,
} from './screens';

const OperationsIndex = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route index element={<Navigate to="/operations/summary" replace />} />
      <Route path="summary" element={<SummaryBoard />} />
      <Route path="branch-health" element={<BranchHealth />} />
      <Route path="alerts" element={<CriticalAlerts />} />
      <Route path="district-demand" element={<DistrictDemand />} />
      <Route path="board" element={<OperationBoard />} />
      <Route path="routes" element={<RouteManagement />} />
      <Route path="vehicles" element={<Vehicles />} />
      <Route path="end-of-day" element={<EndOfDay />} />
      <Route path="*" element={<Navigate to="/operations/summary" replace />} />
    </Route>
  </Routes>
);

export default OperationsIndex;
